// Values of the cache are {err, el} objects.
const sharedImageCache = {};

// Turn on code written based on the theory that browsers are more willing
// to preload and be ready to draw images when they're in the DOM.
const PUT_IN_HIDDEN_DIV = false;

let hiddenDiv;
if (PUT_IN_HIDDEN_DIV && global.document) {
	hiddenDiv = document.createElement("div");
	hiddenDiv.style.display = "none";
	document.body.appendChild(hiddenDiv);
}

// Similar to https://github.com/npm-dom/img/blob/master/index.js but without
// swallowing errors.
const create = function(src, crossOrigin, cb) {
	if (!global.Image) {
		setTimeout(() => cb(null, src), 0);
		return src;
	}

	const el = new Image();
	let locked = false;

	const cleanup = function() {
		el.onload = null;
		el.onerror = null;
		cb = null;
	};

	el.onload = function() {
		if (locked) return;
		locked = true;
		const callback = cb;
		cleanup();
		callback && callback(null, el);
	};

	el.onerror = function(err) {
		if (locked) return;
		locked = true;
		const callback = cb;
		cleanup();
		callback && callback(err, el);
	};

	if (crossOrigin) {
		el.crossOrigin = true;
	}
	el.src = src;
	hiddenDiv && hiddenDiv.appendChild(el);
	return el;
};

const getSrc = function(src, crossOrigin, cb) {
	const key = "src:" + src;
	const cached = sharedImageCache[key];
	if (cached) {
		return cached.el;
	}

	const el = create(src, !!crossOrigin, err => {
		if (err) {
			sharedImageCache[key] = {err, el};
		}
		if (cb) {
			cb(err);
		}
	});

	sharedImageCache[key] = {err: null, el};
	return el;
};

const srcData = function(src, crossOrigin, cb) {
	const key = "src:" + src;
	const cached = sharedImageCache[key];
	if (cached && cached.data) {
		return cached.data;
	} else if (cached && cached.status) {
		sharedImageCache[key].cbList.push(cb);
	} else if (cached && cached.err) {
		return cached.el;
	} else {
		sharedImageCache[key] = {status: 1, cbList: []};
		let imgString;
		const el = create(src, !!crossOrigin, err => {
			if (err) {
				sharedImageCache[key] = {err, el};
			} else {
				const xhr = new XMLHttpRequest();
				xhr.open("GET", src, true);
				xhr.send();
				xhr.onload = function() {
					imgString = xhr.responseText;
					//TODO: this is so slow....
					if (
						sharedImageCache[key].cbList &&
						sharedImageCache[key].cbList.length
					) {
						sharedImageCache[key].cbList.forEach(c => {
							c(imgString);
						});
					}
					if (cb) {
						cb(imgString);
					}
					sharedImageCache[key] = {err: null, el, data: imgString};
				};
			}
		});
		return imgString;
	}
};

module.exports = {
	src: getSrc,
	srcData,
};
